import { readOnlyFieldMTF } from 'app/services/sfAuth/sfData/jsConnectionUtils'
import { isNil } from 'lodash'

export const reviewAssignementFieldsMapSF = {
  direction: 'in',
  Id: 'id',
  Additional_comments_reviewer__c: 'additionalCommentsReviewer',
  Clarity_of_request__c: 'clarityOfRequest',
  Clarity_of_request_comments__c: 'clarityOfRequestComments',
  Clearly_identified_need__c: 'clearlyIdentifiedNeed',
  Clearly_identified_need_comments__c: 'clearlyIdentifiedNeedComments',
  Conflict_Of_Interest_Declaration__c: 'conflictOfInterestDeclaration',
  CreatedById: 'createdById',
  // CreatedDate: 'createdDate',
  Date_accepted_or_declined__c: 'dateAcceptedOrDeclined',
  // Due_date__c: 'dueDate',
  Feasibility_to_deliver_the_project__c: 'feasibilityToDeliverTheProject',
  IsDeleted: 'isDeleted',
  LastModifiedById: 'lastModifiedById',
  LastModifiedDate: 'lastModifiedDate',
  LastReferencedDate: 'lastReferencedDate',
  LastViewedDate: 'lastViewedDate',
  Last_Modified_By__c: 'lastModifiedBy',
  Last_modified_by_portal_user__c: 'lastModifiedByPortalUser',
  Last_modified_through_portal_by__c: 'lastModifiedThroughPortalBy',
  Last_modified_through_portal_by__r: {
    key: 'lastModifiedThroughPortalByName',
    in: (obj) => {
      if (isNil(obj.Last_modified_through_portal_by__r)) {
        return undefined
      }
      return obj.Last_modified_through_portal_by__r.Name
    }
  },
  Name: 'name',
  // Opportunity__c: 'opportunity',
  PM_comments_on_external_review__c: 'pmCommentsOnExternalReview',
  Partnerships__c: 'partnerships',
  Partnerships_comments__c: 'partnershipsComments',
  Project_addresses_identified_need__c: 'projectAddressesIdentifiedNeed',
  Reviewer_Comments__c: 'reviewerComments',
  Reviewer_recommendation__c: 'reviewerRecommendation',
  Scheduler_Test__c: 'schedulerTest',
  Snapshot_About_Me__c: 'snapshotAboutMe',
  Snapshot_Review__c: 'snapshotReview',
  Status__c: 'status',
  Submitted_via_file__c: 'submittedViaFile',
  Survey__c: 'survey',
  SystemModstamp: 'systemModstamp',
  Transformational_impact__c: 'transformationalImpact',
  Transformational_impact_comments__c: 'transformationalImpactComments',
  // User__c: 'user',
  ...readOnlyFieldMTF('User__c', 'user'),
  ...readOnlyFieldMTF('Opportunity__c', 'opportunity'),
  ...readOnlyFieldMTF('CreatedDate', 'createdData'),
  ...readOnlyFieldMTF('ModifiedDate', 'modifiedDate'),
  ...readOnlyFieldMTF('Due_date__c', 'dueDate'),
  Opportunity__r: {
    key: 'opportunity_r',
    in: (obj) => {
      if (isNil(obj.Opportunity__r)) {
        return undefined
      }
      return {
        name: obj.Opportunity__r.Name,
        stageName: obj.Opportunity__r.StageName
      }
    }
  },
  Last_Modified_By__r: {
    key: 'lastModifiedByUserName',
    in: (obj) => {
      if (isNil(obj.Last_Modified_By__r)) {
        return undefined
      }
      return obj.Last_Modified_By__r.Name
    }
  },
  'attributes.type': 'attributesType'
}

export interface ReviewAssignement {
  additionalCommentsReviewer: string | null
  clarityOfRequest: string | null
  clarityOfRequestComments: string | null
  clearlyIdentifiedNeed: string | null
  clearlyIdentifiedNeedComments: string | null
  conflictOfInterestDeclaration: string | null
  createdById: string | null
  createdDate: string | null
  dateAcceptedOrDeclined: string | null
  dueDate: string | null
  feasibilityToDeliverTheProject: string | null
  id: string | null
  isDeleted: boolean | null
  lastModifiedById: string | null
  lastModifiedByUserName: string | null
  lastModifiedDate: string | null
  lastReferencedDate: string | null
  lastViewedDate: string | null
  lastModifiedByUserDate: string | null
  lastModifiedBy: string | null
  lastModifiedByPortalUser: string | null
  lastModifiedThroughPortalBy: string | null
  lastModifiedThroughPortalByName: string | null
  name: string | null
  opportunity: string | null
  opportunity_r: {
    name: string | null
    stageName: string | null
  }
  pmCommentsOnExternalReview: string | null
  partnerships: string | null
  partnershipsComments: string | null
  projectAddressesIdentifiedNeed: string | null
  reviewerComments: string | null
  reviewerRecommendation: string | null
  schedulerTest: boolean | null
  snapshotAboutMe: string | null
  snapshotReview: string | null
  status: string | null
  submittedViaFile: boolean | null
  survey: string | null
  systemModstamp: string | null
  transformationalImpact: string | null
  transformationalImpactComments: string | null
  user: string | null
  attributesType: string | null
}
